import type AttendeeType from 'owa-service/lib/contract/AttendeeType';
import type SingleRecipientType from 'owa-service/lib/contract/SingleRecipientType';

export default function isAttendeeOrganizer(
    organizer: SingleRecipientType,
    attendee: AttendeeType
): boolean {
    return (
        organizer &&
        attendee.Mailbox &&
        organizer.Mailbox &&
        attendee.Mailbox.EmailAddress === organizer.Mailbox.EmailAddress
    );
}
